import { createCliente, updateCliente, getClienteById as getCliente } from "@spark/services/clientes";
import React, { useState, useMemo, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Form } from 'react-final-form';
import { Button, ButtonWithLoading } from '@spark/ui-components/components/Button';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { FormButtonToolbar, FormContainer } from '@spark/ui-components/components/form/FormElements';
import { formStructure, formSections, validateForm } from './formConfig';
import DynamicForm from '@spark/ui-components/components/form/DynamicForm';
import { notification } from '@spark/ui-components/utils/notification';

const mapApiToForm = dados => {
  const mappedData = {
    nome: dados.Nome || '',
    cnpj: dados.Cnpj || '',
    codigoIntegracao: dados.CodigoIntegracao || '',
    telefone: dados.Telefone || '',
    observacoes: dados.Observacao || '',
    email: dados.Email || ''
  };
  return mappedData;
};

const mapFormToApi = values => {
  return {
    Nome: values.nome,
    Cnpj: values.cnpj,
    CodigoIntegracao: values.codigoIntegracao,
    Telefone: values.telefone,
    Observacao: values.observacoes,
    Email: values.email
  };
};

const mapFormToCreateApi = values => {
  return {
    nome: values.nome,
    cnpj: values.cnpj,
    codigoIntegracao: values.codigoIntegracao,
    telefone: values.telefone,
    observacoes: values.observacoes || '',
    email: values.email || ''
  };
};

const getClienteById = async id => {
  const response = await getCliente(id);
  return response;
};

const createClienteById = async payload => {
  const response = await createCliente(payload);
  return response;
};

const updateClienteById = async (id, payload) => {
  const response = await updateCliente(id, payload);
  return response;
};

const Forms = () => {
  const {
    id
  } = useParams();
  const [dadosRecebidos, setDadosRecebidos] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const history = useHistory();
  const isEditMode = !!id; // Carregar dados se estiver em modo de edição

  React.useEffect(() => {
    if (isEditMode) {
      setLoading(true);
      getClienteById(id).then(setDadosRecebidos).catch(() => notification.error('Erro ao carregar dados do cliente.')).finally(() => setLoading(false));
    }
  }, [id, isEditMode]);
  const onSubmit = useCallback(async values => {
    try {
      setSaving(true);
      const payload = mapFormToApi(values);

      if (isEditMode) {
        await updateClienteById(id, payload);
        notification.success('Cliente atualizado com sucesso!');
      } else {
        await createClienteById(payload);
        notification.success('Cliente criado com sucesso!');
      }

      history.push('/pages/clientes');
    } catch (err) {
      notification.error(`Erro ao salvar cliente: ${err.message}`);
    } finally {
      setSaving(false);
    }
  }, [id, isEditMode, history]);
  const initialValues = useMemo(() => {
    if (!dadosRecebidos) return {};
    const mappedValues = mapApiToForm(dadosRecebidos);
    console.log('🎯 InitialValues para o Form:', mappedValues);
    return mappedValues;
  }, [dadosRecebidos]);

  if (loading) {
    return <div style={{
      padding: '20px',
      textAlign: 'center'
    }}>
                <p>⏳ Carregando dados do cliente...</p>
            </div>;
  }

  return <Form onSubmit={onSubmit} initialValues={initialValues} validate={validateForm}>
            {({
      handleSubmit,
      form: {
        reset
      },
      values
    }) => {
      console.log('📝 Valores atuais do formulário:', values);
      return <Card>
                    <CardBody>
                        <FormContainer onSubmit={handleSubmit}>
                            <DynamicForm structure={formStructure} sections={formSections(initialValues)} />
                
                            <FormButtonToolbar className="mt-5 d-flex justify-content-between align-items-center" style={{
              width: '100%'
            }}>
                                <div className="d-flex gap-2">
                                    <ButtonWithLoading variant="primary" type="submit" loading={saving ? 'true' : undefined}>
                      
                                        {isEditMode ? 'Atualizar' : 'Criar'}
                                    </ButtonWithLoading>
                                    <Button variant="secondary" type="button" onClick={() => history.push('/pages/clientes')}>
                                        Cancelar
                                    </Button>
                                </div>
                            </FormButtonToolbar>
                        </FormContainer>
                    </CardBody>
                </Card>;
    }}
        </Form>;
};

export default Forms;
